import Card from 'components/Card/Card';
import { withHappeningCardProps } from 'viewModel/content/happening/withHappeningCardProps';

export default withHappeningCardProps(Card);
